import { ProjectListEntry } from "../core/types";
import { DeleteProjectButton } from "./DeleteProjectButton";

const PROJECT_ENTRY_DEFAULT_IMAGE = "/assets/img/kiste.png";
export const ProjectListCard = (props: { project: ProjectListEntry, key: string, clicked : (project : ProjectListEntry) => void, onProjectDeleted?: () => void }) => {

  const projectCardClicked = () => {
    props.clicked(props.project);
  }

  const imgNotFound = ({ currentTarget }) => {
    if (currentTarget.src !== PROJECT_ENTRY_DEFAULT_IMAGE)
    currentTarget.src=PROJECT_ENTRY_DEFAULT_IMAGE;
  }

  const icon = props.project.icon ? props.project.icon : "/assets/img/kiste.png";
  const imgSrc = props.project.screenshot ? props.project.screenshot : icon;
  const name = props.project.name ? props.project.name : "Sandkasten"
  
  // Show delete button only for real projects (not NEW, quest, directory, etc.)
  // Treat projects without status as "private" (default)
  const isRealProject = props.project.status === "private" || 
                       props.project.status === "public" || 
                       !props.project.status;

  return (<div className="col col-sm-6 col-md-3 col-lg-2 mb-4 project-card codeProjectBtn" onClick={projectCardClicked} id={props.project.id} >
    <div className="card text-center h-100 no-border project-card-content ">
      <img src={imgSrc} onError={imgNotFound} className="card-img-top project-image" alt="Projekt" />
      <div className="project-card-body">
        <p className="card-title project-name">{decodeURIComponent(name)}</p>
        {isRealProject && (
          <div className="mt-2" onClick={(e) => e.stopPropagation()}>
            <DeleteProjectButton 
              projectId={props.project.id} 
              projectName={props.project.name}
              className="btn-sm"
              onDeleted={props.onProjectDeleted}
            />
          </div>
        )}
      </div>
    </div>
  </div>);
}
